<script>
export default {
  name: 'BaseButton',
  props: {
    // 'default' | 'primary' | 'success' | 'warning' | 'danger' | 'info' | ''
    type: {
      type: String,
      required: true,
    },
    // 活性/非活性
    disable: {
      type: Boolean,
      required: true,
    },
    // 'large' | 'default' | 'small'
    size: {
      type: String,
      default: 'default',
    },
    // プレーンボタン
    plain: {
      type: Boolean,
      default: false,
    },
    // 丸いボタン
    round: {
      type: Boolean,
      default: false,
    },
    // 円形ボタン
    circle: {
      type: Boolean,
      default: false,
    },
    // ローディング
    loading: {
      type: Boolean,
      default: false,
    },
    // ラベル
    label: {
      type: String,
      required: true,
    },
    // アイコン（Element UI の場合はクラス名を指定: 'el-icon-plus' など）
    icon: {
      type: String,
      required: false,
    },
      transparent: {
          type: Boolean,
          default: false,
      }
  },

    computed: {
      buttonClass() {
          if (this.disable) {
              return 'disable-command-button'
          }

          return 'enable-command-button'
      },
        transparentClass() {
          return this.transparent ? 'transparent-force' : ''
        },
    },

  methods: {
    buttonClick(e) {
      this.$emit('click', e)
    },
  },
}
</script>

<template>
  <el-button
      :class="['base-button', buttonClass, transparentClass]"
      :type="type"
      :disabled="disable"
      :size="size"
      :plain="plain"
      :round="round"
      :circle="circle"
      :loading="loading"
      :icon="icon"
      @click="buttonClick"
  >
    <!-- 任意アイコンをスロットで差し込めます -->
    <slot></slot>{{ label }}
  </el-button>
</template>

<style scoped>
.base-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    text-align: center;
}

.el-button.base-button.enable-command-button:not(.icon-only-btn),
.el-button.base-button.disable-command-button:not(.icon-only-btn) {
    padding-left: 16px;
    padding-right: 16px;
}

:deep(.base-button > span) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
}

.transparent-force {
    background: transparent !important;
    border: none !important;
}

</style>
